export const initialValues = {
  name: '',
  lat: 0,
  lon: 0,
  street: '',
  city: '',
  state: '',
  zip: '',
};
